var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:{mdButton: _vm.isButton},attrs:{"to":{name: 'BackendUserContractFlow'},"tag":_vm.tagClass()}},[_c('span',{class:{'md-list-item-text': !_vm.isButton}},[_vm._v(_vm._s(_vm.label))]),_c('md-icon',[_vm._v("arrow_right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }